<template>
    <div class="entry "> 
        <!-- <div class="entry-title"> </div> --> 
		<div class="entry-wrapper">
			<div class="wrapper-top" >
				<!-- <div class="top-search">
					<el-autocomplete class="search-input"
						v-model="searchWord"
						:trigger-on-focus="false"
						:fetch-suggestions="querySearch"
						placeholder="请输入患者编号/姓名调取医案信息"
						@select="handleclickId"
					></el-autocomplete>
					 
					<modelTip :ok="'确定'" :show.sync="isNoSeachData" @ok='add_sure'>
						<div slot="content" >
							<p>未检索到医案信息，请重新输入完整的患者编号和姓名。</p>
						</div>
					</modelTip>
					<el-button type="primary"  @click="patientSearch">查 询</el-button>
					<el-button type="primary"  @click="resetSearch">清 空</el-button>
				</div> -->
				<div class="top-version" >
					<span href="javascript:;" size="small" type="primary" @click="version_click(item)" :class="versionType==item.type?'active':''" v-for="(item,index) in version" :key="index">{{ item.value }}</span>
				</div>
			</div>
			<!-- 信息  -->
			<div class="wrapper-patient">
				<div class="patient">
					<el-form class="patient-form"  action="" :model="patientInfo"  @submit.prevent  >
						<div class="input_title" v-if="this.versionType == 1"> 基本信息 </div>
						<div class="patient-form-item" >
							<el-row :gutter="20">
								<el-col>
									<el-form-item label='患者编号' :label-width="labelWidth">
										<el-input
											type="text"
											placeholder="请输入内容"
											class="patient-input"
											v-model="patientInfo.patientId"
										/>
									</el-form-item>
								</el-col>
							</el-row>
							
							<el-row :gutter="20">
								<el-col :span="8">
									<el-form-item label='姓名' :label-width="labelWidth">
										<el-input
											type="text"
											placeholder="请输入内容"
											class="patient-input"
											v-model="patientInfo.patientName"
										/>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label='性别' :label-width="labelWidth">
										<el-radio-group v-removeAriaHidden
											v-model="patientInfo.patientSex">
											<el-radio label="男"></el-radio>
											<el-radio label="女"></el-radio>
											</el-radio-group>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label='年龄' :label-width="labelWidth">
										<el-input
											placeholder="请输入内容"
											type="text"
											class="patient-input"
											v-model="patientInfo.patientAge"
										/>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row :gutter="20">
								<el-col :span="8">
									<el-form-item label='诊次' :label-width="labelWidth">
										<el-input-number placeholder="请输入内容" v-model="patientInfo.patientDiagnosis" :min="1" :max="100" label=""></el-input-number>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label='就诊日期' :label-width="labelWidth">
										<el-input
											placeholder="请输入内容"
											type="text"
											class="patient-input"
											v-model="patientInfo.consultation"
										/>
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label='医师姓名' :label-width="labelWidth">
										<el-input
											placeholder="请输入内容"
											type="text"
											class="patient-input"
											v-model="patientInfo.doctorName"
										/>
									</el-form-item>
								</el-col>
							</el-row>
							<!-- 完整版展示的 -->
							<el-row :gutter="20" v-if="versionType == 2">
								<el-col :span="8">
									<el-form-item label='职业' :label-width="labelWidth">
										<el-input
											placeholder="请输入内容"
											type="text"
											class="patient-input"
											v-model="patientInfo.patientOccupation"
										/>
									</el-form-item>
								</el-col>
								<el-col :span="16">
									<el-form-item label='既往史' :label-width="labelWidth">
										<el-input
											placeholder="请输入内容"
											type="text"
											class="patient-input"
											v-model="patientInfo.diseaseHistory"
										/>
									</el-form-item>
								</el-col>
							</el-row>
						</div>

						<!-- 精简版展示 -->
						<div class="simple" v-if="this.versionType == 1">
							<div class="input_title" > 四诊检查 </div>
							<div class="patient-form-item">
								<el-row :gutter="20">
									<el-col :span="22">
										<el-form-item label='临床表现' :label-width="labelWidth">
											<el-input
												type="textarea"
												class="patient-text"
												placeholder="请输入内容"
												v-model="patientInfo.clinicalFeature"
											/>
										</el-form-item>
									</el-col>
									<el-col :span="2">
										<el-button class="add-icon"  type="text" icon="el-icon-circle-plus-outline" @click="clinical_click"></el-button>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="8">
										<el-form-item label='舌质' :label-width="labelWidth">
											<el-input
												placeholder="请输入内容"
												type="text"
												class="patient-input"
												v-model="patientInfo.tongueNature"
											/>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label='舌苔' :label-width="labelWidth">
											<el-input
												type="text"
												placeholder="请输入内容"
												class="patient-input"
												v-model="patientInfo.tongueCoating"
											/>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label='脉象' :label-width="labelWidth">
											<el-input
												type="text"
												placeholder="请输入内容"
												class="patient-input"
												v-model="patientInfo.pulseCondition"
											/>
										</el-form-item>
									</el-col>
								</el-row>
							</div>

							<div class="input_title" >诊断疗法</div>
							<div class="patient-form-item">
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label='中医疾病' :label-width="labelWidth">
											<el-input
												placeholder="请输入内容"
												type="text"
												class="patient-input"
												v-model="patientInfo.tcmDisease"
											/>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label='西医疾病' :label-width="labelWidth">
											<el-input
												type="text"
												placeholder="请输入内容"
												class="patient-input"
												v-model="patientInfo.wcmDisease"
											/>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label='中医证候' :label-width="labelWidth">
											<el-input
												type="text"
												placeholder="请输入内容"
												class="patient-input"
												v-model="patientInfo.tcmSyndrome"
											/>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label='治法' :label-width="labelWidth">
											<el-input
												type="text"
												placeholder="请输入内容"
												class="patient-input"
												v-model="patientInfo.therapy"
											/>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
							<div class="input_title">治疗疗效</div>
							<div class="patient-form-item">
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label='方剂名称' :label-width="labelWidth">
											<el-input
												type="textarea"
												class="patient-text"
												placeholder="请输入内容"
												v-model="patientInfo.prescription"
											/>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label='中药组成' :label-width="labelWidth">
											<el-input
												type="textarea"
												class="patient-text"
												placeholder="请输入内容"
												v-model="patientInfo.formulaComposition"
											/>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row :gutter="20">
									<el-col :span="12">
										<el-form-item label='穴位' :label-width="labelWidth">
											<el-input
												type="text"
												placeholder="请输入内容"
												class="patient-input"
												v-model="patientInfo.pointSelection"
											/>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item class="simple-select" label='疗效' :label-width="labelWidth">
											<el-select v-model="patientInfo.comprehensive">
												<el-option value="有效">有效</el-option>
												<el-option value="临床痊愈">临床痊愈</el-option>
												<el-option value="无效">无效</el-option>
												<el-option value="显效">显效</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</div>

						<!-- 完整版 -->
						<div class="whole" v-if="this.versionType==2">
							<ul class="complete-input_title">
								<!-- wholeNav -->
								<li :class="wholeActive==item.type?'active':''" 
									v-for="item in wholeNav" :key="item.type" 
									@click="wholeNav_click(item)">{{item.value}}</li>
							</ul>
							
							<div class="patient-form-item">
								<!-- 四诊检查 -->
								<div v-if="wholeActive == 1">
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='并发症' :label-width="labelWidth">
												<el-input
													type="textarea"

													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.complication"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='临床表现' :label-width="labelWidth">
												<el-input
													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.clinicalFeature"
												/>
											</el-form-item>
										</el-col>
										<el-col :span="2">
											<el-button class="add-icon"  type="text" icon="el-icon-circle-plus-outline" @click="clinical_click"></el-button>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='舌质' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.tongueNature"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='舌苔' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.tongueCoating"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='脉象' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.pulseCondition"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='医学检查' :label-width="labelWidth">
												<el-input
													type="textarea"

													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.medicalExamination"
												/>
											</el-form-item>
										</el-col>
										<el-col :span="2">
											<el-button class="add-icon"  type="text" icon="el-icon-circle-plus-outline" @click="medical_click"></el-button>
										</el-col>
									</el-row>
								</div>
								<!-- 诊断疗法 -->
								<div v-else-if="wholeActive==2">
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='西医疾病' :label-width="labelWidth">
												<el-input

													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.wcmDisease"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='中医疾病' :label-width="labelWidth">
												<el-input

													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.tcmDisease"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='中医证候' :label-width="labelWidth">
												<el-input
													type="textarea"

													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.tcmSyndrome"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='治法' :label-width="labelWidth">
												<el-input
													type="textarea"

													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.therapy"
												/>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
								<!-- 治疗与疗效 -->
								<div v-else-if="wholeActive==3">
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='方剂名称' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.prescription"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="11">
											<el-form-item label='用法' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.usageUse"
												/>
											</el-form-item>
										</el-col>
										<el-col :span="11">
											<el-form-item label='其他方药疗法' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.otherPrescriptionTreat"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='中药组成' :label-width="labelWidth">
												<el-input
													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.formulaComposition"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="11">
											<el-form-item label='穴位' :label-width="labelWidth">
												<el-input
													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.pointSelection"
												/>
											</el-form-item>
										</el-col>
										<el-col :span="11">
											<el-form-item label='针灸疗法' :label-width="labelWidth">
												<el-input
													type="textarea"

													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.acupunctureTreat"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='按摩疗法' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.massageTreat"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='西医疗法' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.westernTreat"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='其他疗法' :label-width="labelWidth">
												<el-input
													type="text"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.otherTreat"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="12">
											<el-form-item class="simple-select" label='疗效' :label-width="labelWidth">
												<el-select v-model="patientInfo.comprehensive">
													<el-option value="有效">有效</el-option>
													<el-option value="临床痊愈">临床痊愈</el-option>
													<el-option value="无效">无效</el-option>
													<el-option value="显效">显效</el-option>
												</el-select>
											</el-form-item>
										</el-col>
									</el-row>
								</div>
								<!-- 切换其他页面 -->
								<div v-else-if="wholeActive==4">
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='医案原文' :label-width="labelWidth">
												<el-input
													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.medicineText"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='医案来源' :label-width="labelWidth">
												<el-input
													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.medicineSource"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="22">
											<el-form-item label='备注' :label-width="labelWidth">
												<el-input
													type="textarea"
													class="patient-text"
													placeholder="请输入内容"
													v-model="patientInfo.remark"
												/>
											</el-form-item>
										</el-col>
									</el-row>
									<!-- <el-row :gutter="20">
										<el-col :span="12">
											<el-form-item label='附件' :label-width="labelWidth"> 
												<el-upload
													accept
													action
													:limit="3"
													:file-list="fileList"
													:before-remove="fileBeforeRemove"
													:on-remove="fileHandleRemove"
													:on-preview="fileHandlePreview"
													:on-exceed="fileHandleExceed"
													:http-request="uploadExcel">
													<el-button class="upFile" size="small">选择文件</el-button> 
												</el-upload>
											</el-form-item>
										</el-col>
										<el-col :span="6">
											<el-form-item label-width="10px"><el-button @click='clear_upload' plain type="primary"  size="small">清 空</el-button></el-form-item> 
										</el-col>
									</el-row> -->
								</div>
							</div>		
						</div>
					</el-form>
				</div>
				<div  class="operation">
					<!-- <el-button type="primary"  @click="saveTimes(1)">保存并录入下一诊次</el-button> -->
					<el-button type="primary"  @click="saveTimes(2)">保存至医案库</el-button>
					<el-button type="primary"  @click="clear">清空</el-button>
					<!-- <el-button type="primary"  @click="print_click">打印处方</el-button> -->
				</div>
			</div>
			<!-- 这是打印处方的弹窗 -->
			<printModel :show.sync="printDialog" :patientInfo='patientInfo'> </printModel>

			<!-- 保存选择医案库 -->
			<chooseMedical v-if='libraryDialog' :show.sync="libraryDialog"  @save='saveLibraryList'></chooseMedical>

			<!-- 这是临床表现的弹窗 -->
			<clinicalPicture ref="clinical_picture" :show.sync="clinicalDialog" @save='saveClinical'></clinicalPicture>
			<!-- 这是医学检查的弹窗 -->
			<examination ref="examination" :show.sync="medicalDialog" @save='saveCheck'></examination>
			<!-- 这是上传附件的弹窗 -->
			<el-dialog
				:visible.sync="attchDialog"
				:destroy-on-close="true"
				:close-on-click-modal="false"
				width="28%"
				>
				<el-upload
					class="upload-demo"
					:on-preview="handlePreview"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					:on-success="auploadsucess"
					:headers="headers"
					:action="AuploadUrl()"
					:before-upload="beforeAvatarUpload"
					multiple
					:limit="3"
					accept="'.xlsx','.xls'"
					:on-exceed="handleExceed"
				>
					<button>请选择上传文件</button>

				</el-upload>
				<span slot="footer" class="dialog-footer">
					<el-button @click="attchyep()" style="background: #cfa972"
					>确定</el-button
					>
				</span>
			</el-dialog>
			<Toast></Toast>
		</div> 
    </div>
</template>
<script>

import topHeader from "../components/header.vue";
import bottomFooter from "../components/footer";
import { allUploadFile,addConsiliaData,queryPatientByText,getPatientById} from "../io/api.js";
import importModel from "../components/ui-kit/batch_import.vue"
import printModel from "./records/print_dialog.vue"
import chooseMedical from "../components/ui-kit/choose_medical.vue"
// 临床表现
import clinicalPicture from './records/clinical_picture.vue'
import examination from './records/examination.vue'
import modelTip from '../components/ui-kit/model_tip.vue'
import { mapState, mapActions } from "vuex";
import Toast from '../components/ui-kit/toast.vue' 
import {getCookieInfo} from '../io/getCookie.js'
export default {
    components: {
		topHeader,
		bottomFooter,
        importModel,
		printModel,
		chooseMedical,
		clinicalPicture,
		modelTip,
		examination,
		Toast
    },
	data() {
		return { 
			entryIndex:1,//nav状态
			isShowImport:false,//批量导入
			// 版本控制
			versionType: 1,
			version:[
				{type:1,value:'精简版'},
				{type:2,value:'完整版'}
			],
			wholeActive:1,
			wholeNav:[
				{type:1,value:'四诊检查'},
				{type:2,value:'诊断治法'},
				{type:3,value:'治疗与疗效'},
				{type:4,value:'其他'}
			],
			searchWord:'',
			searchId:'',
			labelWidth:'100px',
			printDialog: false,//打印处方弹层
			clinicalDialog: false,//临床医学检查的弹窗
			medicalDialog: false,//医学检查的弹窗
			getTimer: new Date(),
			libraryDialog: false,//选择医案库
			isEdit:false,//是否编辑
			reqId: this.$route.query.id,//编辑id
			isNoSeachData:false,//未检索到医案信息
			clinicalArr:[],
			fileName:'未选择任何文件',//上传文件名称
			patientInfo: {
				patientDiagnosis:1
			}, //录入的内容
			storeId: "", //选择医案库的id
			saveType:'',//区分保存按钮

			attchDialog: false,
			patientSearchList: "",
			ischecked: false, //搜索下拉框

		
			value: "",
			fileData: "",
			headers: {
				Authorization: "bearer " + window.localStorage.getItem("token")||getCookieInfo('access_token')||'',
			},
		
			fileList: [],
            upFileList:[],
		};
	},
	watch: {
		isShowImport(val,old){
			if(!val){
				this.entryIndex = 1;
			}
		}	
	},
	computed: {
		
	},
	mounted () {
		//只请求一次医案库列表
		// this.getSelfStore_list()	
		if(this.$route.query.navType){
			this.leftNavTab(this.$route.query.navType)
		}
	},
	methods: {
		// ...mapActions(['getSelfStore_list']),
		//获取当前的时间
		getDate() {
			const nowDate = new Date();
			const date = {
				year: nowDate.getFullYear(),

				month: nowDate.getMonth() + 1,

				date: nowDate.getDate(),

				hours: nowDate.getHours(),

				minutes: nowDate.getMinutes(),

				seconds: nowDate.getSeconds(),
			};
			const newmonth = date.month > 10 ? date.month : "0" + date.month;
			const newday = date.date > 10 ? date.date : "0" + date.date;
			const newminutes = date.minutes > 10 ? date.minutes : "0" + date.minutes;
			const newseconds = date.seconds > 10 ? date.seconds : "0" + date.seconds;
			this.getTimer =  date.year +  "-" + newmonth +  "-" + newday +  " " + date.hours + ":" + newminutes +  ":" +  newseconds;

		},
		//输入框联想
		async querySearch(queryString, cb){
			queryPatientByText({word:this.searchWord}).then(res=>{
				let data = res.data
				let results =[]
				if (data && data.code == 0) {
					if(data.data&&data.data.length!=0){
						let list = data.data;
						results = list.map((item)=>{
							return {
								value:item,
								name:item
							}
						})
					}else{
						setTimeout(() => {
							this.isNoSeachData=true;
						}, 500);
					}
				}else {
					this.$message.error(data.msg ||'请求失败～');
				}
				cb(results);
			})
		},
		//版本切换
		version_click(item) {
			this.versionType = item.type;
		},
		// left-nav切换
		leftNavTab(type){
			this.entryIndex=type||1;
			if(type==2){
				this.isShowImport = true;
			}
		},
		//点击下拉框中的某一项
		async handleclickId(item) {
			this.searchWord = item.value;
			this.searchId = this.searchWord.split("id:")[1];
		},
		// 查询内容联想
		async patientSearch() {
			if(this.searchWord==''){
				this.$message.error('请输入查询内容！')
				return
			}
			this.getInfo();
		},
		getInfo(){
			// let id = this.searchWord.split("id:")[1]
			// this.searchId = id?id:this.searchWord;
			getPatientById({id:this.searchId}).then(res=>{
				let data = res.data;
				if (data && data.code == 0) {
					this.patientInfo = data.data;
                    // 显示目录
                    this.fileList = [];
                    let attachmentArr=[];
                    let attachmentDownArr=[];
                    this.upFileList=[];
                    // 先把目录的名称，链接改变成arr格式
                    if(this.patientInfo.attachment!=''){
                        attachmentArr=[].concat(this.patientInfo.attachment!=''&&this.patientInfo.attachment.split('#'));
                    }
                    if(this.patientInfo.attachmentDown!=''){
                        attachmentDownArr=[].concat(this.patientInfo.attachmentDown!=''&&this.patientInfo.attachmentDown.split('#'));
                    }
                    if (attachmentArr&&attachmentArr.length!=0) {
                        attachmentArr.forEach((item,index) => {
                            let nameObj = {
                                yuan:item,
                                hou:attachmentDownArr[index],
                            }
                            this.upFileList.push(nameObj)
                            let fileObj={
                                name:item,
                            }
                            this.fileList.push(fileObj)
                        }); 
                    }
				}else{
					this.$message.error(data.msg||'请求失败～')
				}
			})
		},
		// 查询清空
		resetSearch(){
			this.searchWord="";
			this.searchId='';
		},
		// 未检索到医案信息确定按钮
		add_sure(){
			this.isNoSeachData = false
		},
		//打印处方按钮
		print_click() {
			this.printDialog = true;
			this.getDate();
		},
		
		// 完整版nav切换
		wholeNav_click(item){
			this.wholeActive=item.type
		},
		//点击保存保存并录入下一诊次和保存至医案库
		async saveTimes(type) {
			if(!this.patientInfo.patientId){
				this.$message.error('请输入患者编号')
				return
			}else if(!this.patientInfo.patientDiagnosis){
				this.$message.error('请输入诊次')
				return
			}
			this.saveType = type;
			this.$message({
				message: '保存成功',
				type: 'success'
			});
			this.patientInfo.patientDiagnosis+=1;
			this.clear_layer();
            // if(this.patientInfo.storeId){
            //     this.saveLibraryList(this.patientInfo.storeId);
            // }else{
            //     this.libraryDialog = true;
            // }
		},
		//保存选择医案库
		async saveLibraryList(id) {
			this.libraryDialog = false;    
			this.patientInfo.storeId=id;  
            let attachmentArr=[];
            let attachmentDownArr=[];
            this.upFileList.forEach(item=>{
                attachmentArr.push(item.yuan);
                attachmentDownArr.push(item.hou);
            })
            this.patientInfo.attachment =attachmentArr.join("#")
            this.patientInfo.attachmentDown =attachmentDownArr.join("#")
			addConsiliaData({...this.patientInfo,}).then(res=>{
				let data = res.data;
				if (data && data.code == 0) {
					this.$message({
						message:'保存成功！',
						type: "success",
					});
					this.searchId = data.data.patientId;
					this.isShowImport = false;
					if(this.saveType==1){
						//保存并录入下一诊次
						// this.getInfo();
                        this.patientInfo.patientDiagnosis+=1;
						this.clear_layer();
					}else{
                        this.clear();
                    }
					this.saveType='';
				}else{
					this.$message.error(data.msg||'请求失败～')
				}
			})
		},
		//清空录入内容
		clear() {
			this.patientInfo = {};
			this.clear_layer();
			this.resetSearch();
			// this.setRecordId('')
		},
		//清空临床表现和医学检查弹层数据
		clear_layer(){
			this.$refs.clinical_picture.clearTitle();
			this.$refs.examination.clearTitle();
		},
		//临床表现点击加号的弹窗
		clinical_click() {
			this.clinicalDialog = true;
		},
		saveClinical(arr) {
			this.clinicalDialog = false;
			this.patientInfo.clinicalFeature =this.chooseArr(arr,this.patientInfo.clinicalFeature)
			this.$refs.clinical_picture.clearTitle();
		},
		// 医学检查
		saveCheck(arr) {
			this.medicalDialog = false;
			this.patientInfo.medicalExamination =this.chooseArr(arr,this.patientInfo.medicalExamination)
			this.$refs.examination.clearTitle();
		},
		//处理弹层数据回显
		chooseArr(arr,info){
			let contInfo=[]
			arr.forEach(item=>{
				let unitText = item.unit?`(${item.unit})`:'';
				if (item.title) {
					contInfo.push(item.name + "【" + item.title +unitText+ "】");
				}
			})
			if(contInfo.length==0)return
			return (info?info:'')+contInfo.toString(); 
		},
		medical_click() {
			this.medicalDialog = true;
		},
		 // 上传文件
        uploadExcel(param) {
            let formData = new FormData();
            formData.append("file", param.file);
            allUploadFile(formData).then((res) => {
                this.fileName = param.file.name;
                if(res.data&&res.data.data){
                    this.upFileList.push(res.data.data)
                   	// this.patientInfo.attachment = Object.keys(response.data).toString();
					// this.patientInfo.attachmentDown = Object.values(response.data).toString();
					// console.log(this.patientInfo.attachment, 333333333);
                }else{
                    this.$message.error(res.data.msg ||'请求失败～');
                }
            });
        },
        fileHandleExceed(files, fileList) {
            this.$message.warning(`限制上传 3 个文件`)
            // this.$message.warning(`限制上传 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        fileBeforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        fileHandlePreview(file) {
           
            // this.attachment.splice(this.directoryUrl.indexOf(url),1); 
        },
        fileHandleRemove(file, fileList) {
            let name = file.name || file.response.name;
            this.upFileList.forEach((item,index)=>{
                if(item.yuan==name){
                    this.upFileList.splice(index,1); 
                }
            })
        },
		//清空上传文件
		clear_upload(){
			this.fileName = '';
			this.patientInfo.attachment = '';
			this.patientInfo.attachmentDown = '';
            this.upFileList=[];
            this.fileList=[];
		},
		uploadUrl: function () {
		// return "http://127.0.0.1:8080/chuancheng-api/yacj/getExcel";
			return "https://www.yiankb.com/chuancheng-api/yacj/getExcel";
		},
		AuploadUrl: function () {
		// return "http://127.0.0.1:8080/chuancheng-api/yacj/allUploadFile";
			return "https://www.yiankb.com/chuancheng-api/yacj/allUploadFile";
		},
		handleRemove(file, fileList) {
		// console.log(file, fileList);
		},
		handlePreview(file) {
		// console.log(file);
		},
		handleExceed(files, fileList) {
		this.$message.warning(
			`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
			files.length + fileList.length
			} 个文件`
		);
		},
		beforeRemove(file, fileList) {
		return this.$confirm(`确定移除 ${file.name}？`);
		},

		beforeAvatarUpload(file, fileList) {
			this.fileData = file; // 保存当前选择文件
			if (!file) {
				//如果没有文件
				return false;
			} else if (!/.(xls|xlsx)$/.test(file.name.toLowerCase())) {
				this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
				return false;
			}
		},
		//上传附件成功(){
		auploadsucess(response, file, fileList) {
			this.patientInfo.attachment = Object.keys(response.data).toString();
			this.patientInfo.attachmentDown = Object.values(response.data).toString(); 
			if (response.code == 0) {
				this.$message.success("上传成功");
			} else {
				this.$message.error("上传失败");
			}
		},


		//点击上传按钮
		attchupload() {
			this.attchDialog = true;
		},
		attchyep() {
			this.attchDialog = false;
		},

		
	},
};
</script>
<style lang="less" >
	@import url("../css/records/records.less");
</style>